export const SUMMARY_ITEMS = [
  { href: '#contexte', label: 'Contexte' },
  { href: '#definition', label: "La facture électronique c'est quoi ?" },
  { href: '#concernes', label: 'Qui est concerné ?' },
  { href: '#reforme', label: 'Que prévoit la réforme ?' },
  { href: '#plateforme-agre', label: "Qu'est ce qu'une Plateforme Agrée ?" },
  { href: '#e-invoicing', label: "Qu'est ce que l'E-invoicing ?" },
  { href: '#e-reporting', label: "Qu'est ce que l'E-reporting ?" },
  { href: '#calendrier', label: 'Calendrier' },
  { href: '#obligations-des-entreprises', label: 'Obligations des entreprises' },
  { href: '#avantages-de-la-reforme', label: 'Avantages de la réforme' },
  { href: '#mode-operatoire', label: 'Mode opératoire' },
  { href: '#statuts', label: 'Cycle de vie et statuts' },
  { href: '#votre-partenaire-de-confiance', label: 'Votre partenaire de confiance' },
];

export const STATUTS_OBLIGATOIRES = [
  {
    nom: 'Déposée',
    role: 'Confirme que la facture a bien été transmise à la plateforme',
    declencheur: 'Automatique (système)',
    utilite: 'Démarre le suivi de la facture',
  },
  {
    nom: 'Rejetée',
    role: 'Signale une anomalie technique ou de format empêchant la réception',
    declencheur: 'Automatique (plateforme)',
    utilite: 'Nécessite correction : la facture n’est pas émise',
  },
  {
    nom: 'Refusée',
    role: 'Le client refuse la facture (ex : erreur de prix, référence, produit)',
    declencheur: 'Manuel (client ou émetteur)',
    utilite: 'Gère les litiges commerciaux',
  },
  {
    nom: 'Encaissée',
    role: 'Marque le paiement partiel ou total de la facture',
    declencheur: 'Manuel (émetteur ou automatisé depuis un ERP)',
    utilite: 'Permet le suivi du règlement et de la TVA due',
  },
];

export const STATUTS_RECOMMANDES = [
  {
    nom: 'Mise à disposition',
    role: 'Indique que la facture est désormais disponible pour le client (via PA ou portail PPF)',
    declencheur: 'Automatique (plateforme)',
    utilite: 'Permet au client de prendre connaissance de la facture',
  },
  {
    nom: 'Rejetée (technique)',
    role: 'Signalement automatique d’un rejet dû à une non-conformité technique (format, données manquantes)',
    declencheur: 'Automatique (plateforme)',
    utilite: 'Nécessite correction et nouvel envoi',
  },
  {
    nom: 'Prise en charge',
    role: 'Le client a pris en compte la facture, sans pour autant l’avoir encore validée ou réglée',
    declencheur: 'Manuel ou automatique (client)',
    utilite: 'Permet d’indiquer un début de traitement dans les systèmes clients',
  },
  {
    nom: 'Encaissée',
    role: 'Le paiement a été reçu (ou un avoir remboursé), et les données sont intégrées au suivi TVA',
    declencheur: 'Manuel ou automatique via ERP',
    utilite: 'Alimente la déclaration de TVA, surtout en régime sur les encaissements',
  },
];

export const STATUTS_LIBRES = [
  {
    nom: 'Émise par la plateforme',
    role: 'Indique que la plateforme du fournisseur a bien pris en charge la facture et l’a émise',
    declencheur: 'Automatique (plateforme fournisseur)',
    utilite: "Confirme l'envoi effectif de la facture",
  },
  {
    nom: 'Reçue par la plateforme',
    role: 'La facture est bien parvenue à la plateforme du destinataire, mais pas encore visible par le client',
    declencheur: 'Automatique (plateforme destinataire)',
    utilite: 'Suivi logistique de la transmission',
  },
  {
    nom: 'En litige',
    role: 'Un différend est signalé sur le contenu de la facture (montant, référence, etc.)',
    declencheur: 'Manuel (client ou fournisseur)',
    utilite: 'Permet de suspendre ou annuler le processus de validation/paiement',
  },
  {
    nom: 'Suspendue',
    role: 'Traitement en pause dans l’attente de justificatifs (bons de livraison, commande, etc.)',
    declencheur: 'Manuel (client ou plateforme)',
    utilite: 'Évite de rejeter une facture en attente d’éléments complémentaires',
  },
  {
    nom: 'Complétée',
    role: 'Les pièces justificatives ont été ajoutées, la facture peut poursuivre son traitement',
    declencheur: 'Manuel (fournisseur)',
    utilite: 'Réactive le flux après un blocage temporaire',
  },
];
